import React from "react";

const LockCloudGraphic = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="30" cy="30" r="30" fill="rgba(255, 255, 255, 0.05)" />
    <path d="M22 28V23C22 18.5817 25.5817 15 30 15C34.4183 15 38 18.5817 38 23V28" stroke="#FE5A97" strokeWidth="3" strokeLinecap="round" />
    <rect x="18" y="28" width="24" height="20" rx="4" fill="#FE5A97" />
    <circle cx="30" cy="38" r="3" fill="#ffffff" />
    <path d="M12 28C10.8954 28 10 28.8954 10 30C10 31.1046 10.8954 32 12 32H16V28H12Z" fill="#ffffff" />
    <circle cx="16" cy="30" r="3" fill="#ffffff" />
    <path d="M48 24C46.8954 24 46 24.8954 46 26C46 27.1046 46.8954 28 48 28H52V24H48Z" fill="#ffffff" />
    <circle cx="46" cy="26" r="3" fill="#ffffff" />
  </svg>
);

export default LockCloudGraphic;
